<script setup lang="ts">
const props = defineProps({
	icon: {
		type: String,
		required: true
	},
	size: {
		type: Number,
		default: 16
	},
	outline: {
		type: Boolean,
		default: false
	},
	disabled: {
		type: Boolean,
		default: false
	}
});

const iconStyles = computed((): Record<string, string> => {
	const sizePx = props.size + "px";

	return { fontSize: sizePx };
});
const outlineClasses = computed(() => props.outline && "border border-gray-200 active:elevation-cta-shadow-border");
const disabledClasses = computed(() => props.disabled ? "cursor-default text-gray-300" : "hover:bg-gray-50 active:bg-gray-50 active:text-violet-600");
const buttonClasses = computed(() => [outlineClasses.value, disabledClasses.value]);
</script>

<template>
	<button
		class="flex items-center justify-center rounded-sm w-6 h-6 duration-75"
		:class="buttonClasses"
	>
		<NuxtIcon :name="icon" :style="iconStyles" />
	</button>
</template>
